import React, {useEffect} from "react";
import {Select} from "antd";
import {CaretDownFilled} from "@ant-design/icons"
import {FilterWrapper, Root, Title} from "./styled";
import {useBranchContext} from "contexts/BranchProvider";
import {useDashboardContext} from "contexts/DashboardProvider";
import {isAdmin} from "utils/auth";

const Header = () => {

  const {state, fetchData, updateState} = useDashboardContext()
  const BranchContext = useBranchContext()

  useEffect(() => {
    BranchContext.fetchAll()
  }, [])

  useEffect(() => {
    if(isAdmin()) {
      BranchContext.fetchAll()
    }
    fetchData()
    fetchData("counts")
    fetchData("chart_sales")
    fetchData("chart_expenses")
  }, [state.branch_id])

  return (
    <Root>
      <Title>Dashboard</Title>
      <FilterWrapper>
        {isAdmin() && (
          <Select
            size={"large"}
            fieldNames={{value: "id", label: "name"}}
            value={state.branch_id}
            onChange={(value) => updateState({ branch_id: value })}
            options={[
              {id: "", name: "All Branch"},
              ...BranchContext.state.listAll
            ]}
            suffixIcon={<CaretDownFilled />}
          />
        )}
      </FilterWrapper>
    </Root>
  )
}

export default Header
